var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',_vm._g(_vm._b({staticStyle:{"width":"90px"},attrs:{"controls-position":"right","size":"mini","step":0.5,"min":0,"max":100}},'el-input-number',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }